<div class="udex-grid udex-mx-auto">
  <div class="row udex-mt-56 udex-mt-lg-84 udex-pb-56 udex-pb-lg-84">
    <div class="col-lg-8 col-12">
      @if (isApiCallFailed) {
        <dcp-generic-call-error [isOpen]="isApiCallFailed"></dcp-generic-call-error>
      }

      <div [class.mb-6]="!isApiCallFailed && (!!(dcpGlobalMessageService.getMessagesDisplayed$() | async))">
        <dcp-disposable-message></dcp-disposable-message>
      </div>

      @if (backUrl) {
        <udex-button
          class="udex-mb-32 udex-p-0"
          id="backButton"
          size="Large"
          design="Secondary"
          (click)="onBackClick()">
          {{ 'common.back' | cxTranslate }}
        </udex-button>
      }

      <!-- Account Details Section-->
      <div data-cy="account-details" class="udex-mb-20">
        <h4 class="heading__regular--xs udex-mb-20">
          {{ 'checkout.digitalNativeCheckout.accountDetails' | cxTranslate }}
        </h4>
        @if (b2bUnitContacts$ && currentUser) {
          <dcp-buyer-details
            data-cy="buyer-details"
            class="d-block udex-mb-32"
            [b2bUnitContacts$]="b2bUnitContacts$"
            [currentUser]="currentUser">
          </dcp-buyer-details>
        }

        <hr class="udex-mb-32 udex-mt-0">

        @if (!isCurrentUserIndividual && b2bUnitAddresses$) {
          <dcp-company-details
            data-cy="company-details"
            [b2bUnitAddresses$]="b2bUnitAddresses$">
          </dcp-company-details>
        }
      </div>

      <!-- Payment Details -->
      <h4
        role="heading"
        class="heading__regular--xs udex-mb-20 udex-mt-20 udex-mt-sm-0">
        {{ 'checkout.digitalNativeCheckout.payment' | cxTranslate }}
      </h4>

      @if (b2bUnitAddresses$ && b2bUnitContacts$ && currentUser) {
        <dcp-payment-method-display
          data-cy="payment-method-selection"
          [currentUser]="currentUser"
          [b2bUnitAddresses$]="b2bUnitAddresses$"
          [b2bUnitContacts$]="b2bUnitContacts$">
        </dcp-payment-method-display>
      }

      @if ((isTaxValidationSkipped$ | async) === false || (isTaxValidationSkipped$ | async) === undefined) {
        <dcp-tax-information
          data-cy="tax-information-section"
          class="d-block udex-mb-12"
          [b2bUnit$]="b2bUnit$"
          [taxValidationSubject]="taxValidationSubject">
        </dcp-tax-information>
      }
    </div>

    <div class="col-12 col-lg-4 udex-mt-56 udex-mt-lg-0">
      <dcp-summary
        data-cy="dcp-summary"
        (b2bUnitUpdateCallFailed)="onB2bUnitUpdateCallFailed()"
        [selectedView]="view.DataEntry"
        [taxValidationSubject]="taxValidationSubject">
      </dcp-summary>
    </div>

  </div>
</div>
